"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetObjectAclInput_1 = require("./GetObjectAclInput");
var GetObjectAclOutput_1 = require("./GetObjectAclOutput");
var NoSuchKey_1 = require("./NoSuchKey");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetObjectAcl = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetObjectAcl",
    http: {
        method: "GET",
        requestUri: "/{Bucket}/{Key+}?acl"
    },
    input: {
        shape: GetObjectAclInput_1.GetObjectAclInput
    },
    output: {
        shape: GetObjectAclOutput_1.GetObjectAclOutput
    },
    errors: [
        {
            shape: NoSuchKey_1.NoSuchKey
        }
    ]
};
//# sourceMappingURL=GetObjectAcl.js.map